import React, {ChangeEvent, FunctionComponent} from 'react';
import cn from 'classnames';
import {IRadioInput} from './interfaces';
import './styles.scss';

interface IInputRadio {
  inputs: IRadioInput[]
  value: string
  onChange: (value: string) => void
  label: string
  required?: boolean
  labelOnNewLine?: boolean
  className?: string
}

export const InputRadio: FunctionComponent<IInputRadio> = ({
  inputs,
  value,
  onChange,
  label,
  required,
  labelOnNewLine,
  className
}: IInputRadio) => {
  function handleChangeRadio(e: ChangeEvent<HTMLInputElement>) {
    onChange(e.target.value);
  }

  return <div className={cn(labelOnNewLine ? 'input-radio__wrap-column' : 'input-radio__wrap', className)}>
    {<div className="input-radio__label">
      {label}
      {required && <span className={'input-radio__required'}>*</span>}
    </div>}
    <div className="input-radio__values">
      {
        inputs.map((radio) => {
          return <div key={`input-radio_${radio.id}`} className="input-radio">
            <input
              className='input-radio__field'
              id={`input-radio_${radio.id}`}
              type='radio'
              name={radio.name}
              value={radio.value}
              checked={value === radio.value}
              onChange={handleChangeRadio}
            />
            <label
              className='input-radio__value-label'
              htmlFor={`input-radio_${radio.id}`}>
              {radio.label}
            </label>
          </div>;
        })
      }
    </div>
  </div>;
};
